// Curated static list of Lucide icon kebab-case names for the icon picker.
// Keeping this static avoids dynamic imports and keeps the bundle small.

export const ICON_LIST = [
  "activity",
  "alert-circle",
  "alert-triangle",
  "anchor",
  "archive",
  "arrow-right",
  "badge",
  "bar-chart-2",
  "bar-chart",
  "bell",
  "book-open",
  "book",
  "box",
  "briefcase",
  "building-2",
  "building",
  "calendar",
  "check-circle",
  "check-square",
  "chevron-right",
  "circle",
  "clipboard",
  "clock",
  "cloud",
  "code",
  "cog",
  "coins",
  "command",
  "compass",
  "cpu",
  "credit-card",
  "database",
  "dollar-sign",
  "download",
  "edit",
  "external-link",
  "file-text",
  "file",
  "filter",
  "flag",
  "folder",
  "globe",
  "grid",
  "hash",
  "heart",
  "help-circle",
  "home",
  "image",
  "inbox",
  "info",
  "key",
  "layers",
  "layout",
  "link",
  "list",
  "loader",
  "lock",
  "mail",
  "map",
  "message-square",
  "monitor",
  "more-horizontal",
  "package",
  "paperclip",
  "pen-tool",
  "percent",
  "phone",
  "pie-chart",
  "pin",
  "play",
  "plus-circle",
  "printer",
  "refresh-cw",
  "search",
  "send",
  "server",
  "settings",
  "share-2",
  "shield",
  "shopping-bag",
  "shopping-cart",
  "sliders",
  "star",
  "tag",
  "target",
  "terminal",
  "thumbs-up",
  "wrench",
  "trash-2",
  "trending-up",
  "truck",
  "upload",
  "user",
  "users",
  "wallet",
  "zap",
] as const;

export type IconName = (typeof ICON_LIST)[number];
